import React from "react";
import { HomePreviewHeaderTemplate } from "themes/application/home/components";

function HomePreviewHeader(props) {
    return <HomePreviewHeaderTemplate {...props} />;
}

export default HomePreviewHeader;
